import React, { useState } from 'react'
import Allproducts from '../../Index/tab/Allproducts'

const Procedure = () => {
    const [active, setActive] = useState("processing")

    const products = [
        {
            prod: 'Processing & Shipping Time',
            active: "processing",
        },
        {
            prod: 'Payment Policies',
            active: "payment"
        },
        {
            prod: 'Department Policy',
            active: "department"
        },
    ]

    const handleActiveClick = (index) => {
        setActive(index)
    }

    const tab = [
        {
            product: "All orders will be shipped within 3-7 Days from our warehouse.  We ship the orders via DHL Express/ UPS/ ARAMEX after receiving full payment of the order. Payment via wire usually takes 3- 7 business days to receive payment. Payment via cryptocurrency payment gateway would take less than an hour to receive payment.International shipping usually takes about 10-14 business days.   * All sales are final and non- refundable On any Terms." },
        { product: "COMING SOON" },
        { product: "COMING SOON" }

    ]
    const activeIndex = products.findIndex(item => item.active === active);

    return (
        <div>
            <div className='flex flex-col gap-4 border-2 py-3 rounded-lg'>
                <div className='flex flex-row gap-4 border-b-[1px] border-blue-400'>
                    {
                        products.map((p, i) => {
                            return (
                                <div key={i} onClick={() => handleActiveClick(p.active)} className={`flex px-2 cursor-pointer text-white lg:text-[20px] text-[12px] text-opacity-75 ${active === p.active ? "border-b-2 border-[#347BD6] text-blue-400" : ""}`}>
                                    <p>{p.prod}</p>
                                    {/* <p>{p.prod}</p> */}
                                </div>
                            )
                        })
                    }
                </div>
                <div className='p-2'>
                    {tab[activeIndex].product}
                </div>
            </div>

        </div>
    )
}

export default Procedure